/**
 * Shared styles for the Agents console's ticket filter bar (moved out of
 * AgentControlPage so the extracted filter components and the page agree).
 */
import type React from 'react';
import { tvTokens } from '../../../shared/components/triveny';

// A small row label + the pill-chip factory shared by every filter row (active = accent-tinted).
export const filterLabel: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  fontFamily: tvTokens.fontMono,
  fontSize: 10,
  fontWeight: 600,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  color: tvTokens.ink400,
  minWidth: 66,
};

export const filterChip = (active: boolean): React.CSSProperties => ({
  fontFamily: tvTokens.fontMono,
  fontSize: 10.5,
  fontWeight: 600,
  padding: '3px 10px',
  borderRadius: 20,
  cursor: 'pointer',
  border: `1px solid ${active ? tvTokens.accent : tvTokens.border}`,
  background: active ? tvTokens.accentSoft : 'transparent',
  color: active ? tvTokens.accentInk : tvTokens.ink500,
});

export const smallButton: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  padding: '4px 9px',
  borderRadius: tvTokens.r,
  border: `1px solid ${tvTokens.border}`,
  background: tvTokens.paper,
  color: tvTokens.ink500,
  fontSize: 11.5,
  fontWeight: 600,
  cursor: 'pointer',
};

export const popover: React.CSSProperties = {
  position: 'absolute',
  top: 'calc(100% + 4px)',
  left: 0,
  zIndex: 20,
  minWidth: 240,
  maxWidth: 320,
  padding: 8,
  borderRadius: tvTokens.r,
  border: `1px solid ${tvTokens.border}`,
  background: tvTokens.paper,
  boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
};

export const linkButton: React.CSSProperties = {
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  fontSize: 11.5,
  color: tvTokens.accentInk,
};
